import * as React from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

export const DiscoverUnselected = (props: SvgProps) => {
  const { color } = props
  return (
    <Svg width='25' height='25' viewBox='0 0 25 25' fill='none' {...props}>
      <Path
        d='M20 10.5C20 15.7467 15.7467 20 10.5 20C5.25329 20 1 15.7467 1 10.5C1 5.25329 5.25329 1 10.5 1C15.7467 1 20 5.25329 20 10.5Z'
        stroke={color}
        strokeWidth='2'
        strokeMiterlimit='10'
      />
      <Path
        d='M17.499 17.501L23.999 23.999'
        stroke={color}
        strokeWidth='2'
        strokeMiterlimit='10'
        strokeLinecap='round'
      />
    </Svg>
  )
}
